import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import AppState, { POPUPS, SCREENS } from '@/js/AppState';

import Module from './Module';

import classes from './ScreenModules.module.css';
import Catalogue from '@/js/Catalogue/Catalogue';
import CatalogueButton from '@/components/Hud/CatalogueButton/CatalogueButton';
import PopupsManager from 'react-sdk/PopupsManager';
import PopupCatalogue from '@/components/popups/PopupCatalogue/PopupCatalogue';
import GameOverlay from '../ScreenGame/GameOverlay';
import AudioButton from '@/components/Hud/AudioButton/AudioButton';

const ScreenModules = () => {

  // const [extend, setExtend] = useState(0);

  // useEffect(() => {
  //   setExtend(0)
  // }, []);

  const module2Disabled = AppState.module2ToUnlock || (!AppState.debugMode && AppState.moduleStars.module1.training == null);
  const module3Disabled = AppState.module3ToUnlock || (!AppState.debugMode && AppState.moduleStars.module2.training == null);

  function openSuccubusLink()
  {
    window.open("https://www.succubus.fr/", '_blank').focus();
  }

  return (

    <div className={classes.ScreenModulesContainer}>
      <div className={classes.ScreenModules}>
        <div className={classes.content}>
          <div className={classes.modules}>
            <Module
            id={1}
            bgImageLink={"module1.jpg"} />

            <Module
            id={2}
            bgImageLink={"module2.jpg"} />

            <Module
            id={3}
            bgImageLink={"module3.jpg"} />
          </div>
        {Catalogue.unlocked.length > 0 &&
        <CatalogueButton />}
        </div>
      </div>

      <AudioButton />

      {PopupsManager.isOpened(POPUPS.CATALOGUE) &&
      <GameOverlay  />}
      {PopupsManager.isOpened(POPUPS.CATALOGUE) &&
      <PopupCatalogue />}
    </div>
  );
};

export default  observer(ScreenModules)
